// extracted by mini-css-extract-plugin
module.exports = {"ellipsisContainer":"ah_ai","ellipsis":"ah_aj"};